/**
 * Check if fade effect should be used on predefined URLs
 * @returns {boolean} true if it can be used, false otherwise
 */
const isFadeEnabled = () => {
  const isBrowser = () => typeof window !== 'undefined';

  const url = isBrowser() && location.href;
  return isBrowser() && !url.includes('news/');
};

export default isFadeEnabled;
